import I18n from 'I18n';
import { CONTENT_VALIDATION_ERRORS, VALIDATION_ERRORS } from 'personalization-lib/constants/validation';
export const getErrorType = error => error.errorType;
const hasError = (validationErrors, errorType) => validationErrors.some(error => getErrorType(error) === errorType);
const getAssetValidationErrorMessage = ({
  contentValidationError
}) => {
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_OF_A_VARIANT) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.isVariant');
  }
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_FROM_AB_TEST) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.isInAbTest');
  }
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_FROM_LANGUAGE_VARIANT || contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_FROM_LANGUAGE_MASTER) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.hasLanguageVariants');
  }
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_OF_CONTENT_WITH_AUDIENCE_ACCESS) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.hasAudienceAccess');
  }
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_WITH_SMART_CONTENT) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.hasSmartContent');
  }
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_OF_EMBEDDED_WEB_INTERACTIVE) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.isEmbeddedWebInteractive');
  }
  if (contentValidationError === CONTENT_VALIDATION_ERRORS.CANNOT_CREATE_VARIANT_OF_FEEDBACK_SURVEY_WEB_INTERACTIVE) {
    return I18n.text('personalizationLib.shared.tooltips.assetNotPersonalizable.isFeedbackSurvey');
  }

  // Default message
  return I18n.text('personalizationLib.shared.tooltips.assetCannotBePersonalized');
};
export const getValidationErrorMessage = (validationErrors, assetType) => {
  if (!validationErrors.length) {
    return undefined;
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.MISSING_PERSONALIZE_EDIT_SCOPE)) {
    return I18n.text('personalizationLib.shared.tooltips.noPersonalizeEditScope');
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.MISSING_ASSET_AI_SCOPE) || hasError(validationErrors, VALIDATION_ERRORS.GENERATIVE_AI_DISABLED)) {
    return I18n.text('personalizationLib.shared.tooltips.noGenAIAccess');
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.NO_WRITE_SCOPE)) {
    return I18n.text('personalizationLib.shared.tooltips.noAvailableAssetTypes');
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.MISSING_ASSET_WRITE_SCOPE)) {
    return I18n.text(`personalizationLib.shared.tooltips.assetAccess.create.${assetType.toString()}`);
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.STRATEGY_LIMIT_REACHED)) {
    return I18n.text('personalizationLib.shared.tooltips.maxStrategiesReached');
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.STRATEGY_VARIANT_LIMIT_REACHED)) {
    return I18n.text('personalizationLib.shared.tooltips.maxVariantsReached');
  }
  const assetNotPersonalizableError = validationErrors.find(error => getErrorType(error) === VALIDATION_ERRORS.ASSET_NOT_PERSONALIZABLE);
  if (assetNotPersonalizableError) {
    return getAssetValidationErrorMessage(assetNotPersonalizableError);
  }
  if (hasError(validationErrors, VALIDATION_ERRORS.UNSUPPORTED_ASSET_TYPE)) {
    return I18n.text('personalizationLib.shared.tooltips.unsupportedAssetType');
  }
  return undefined;
};